export const SET_LOAN_OFFICERS = "SETTINGS_SET_LOAN_OFFICERS";
export const SET_ERROR = "SETTINGS_SET_ERROR";
export const TOGGLE_LOADING = "SETTINGS_TOGGLE_LOADING";
export const SET_LOAN_OFFICER_SELECTED = "SETTINGS_SET_LOAN_OFFICER_SELECTED";
